import axios, { type AxiosHeaders, type AxiosHeaderValue, type AxiosResponseHeaders, type AxiosError, type AxiosRequestConfig } from "axios";
import { removeUser } from "redux/authSlice";
import { store } from "redux/store";

const instance = axios.create();

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response && error.response.status === 401) {
			store.dispatch(removeUser());
			console.warn("You must be logged in to perform this action!");
		}
		return Promise.reject(error);
	},
);

type SuccessResponse<T> = {
	success: true;
	status: number;
	data: T;
	headers?: AxiosResponseHeaders | Partial<AxiosHeaders & { "Content-Length": AxiosHeaderValue; "Content-Encoding": AxiosHeaderValue; "Content-Type": AxiosHeaderValue; Server: AxiosHeaderValue; "Cache-Control": AxiosHeaderValue; }>
};

type ErrorResponse = {
	success: false;
	status: number;
	errorMessage: string;
};

type ApiResponse<T> = SuccessResponse<T> | ErrorResponse;

export const clearAxiosAuthorization = () => {
	instance.defaults.headers.common.Authorization = undefined;
};

const axiosRequest = async <T,>(method: "GET" | "POST" | "PUT" | "DELETE", url: string, data?: any, config: AxiosRequestConfig = {}, returnHeaders = false): Promise<ApiResponse<T>> => {
	try {
		const response = await instance.request<T>({ ...config, method, url, data });
		if (returnHeaders) 
			return {
				success: true,
				status: response.status,
				data: response.data,
				headers: response.headers,
			}
		
			return {
				success: true,
				status: response.status,
				data: response.data,
			}
	} catch (error) {
		const axiosError = error as AxiosError;
		const responseData = axiosError.response?.data as { errorMessage?: string };
		const errorData = responseData?.errorMessage || "Došlo k neočekávané chybě!";

		return {
			success: false,
			status: axiosError.response?.status || 500,
			errorMessage: errorData,
		};
	}
};

export default axiosRequest;
